/* eslint-disable no-unused-expressions */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/unbound-method */
import UserPersonalInfoApi, { personalInfoCheck } from '@/api/userPersonalInfo';
import './store';

import type { UserVo } from '@/vo/user';

import { Debounce } from '@/shared/decorators/debounce';
import {
  Form,
  ValidateError,
} from '@hb/finance-ui';
import { Toast, Button } from '@hb/coffee';
import {
  Component,
  Mixins,
  Prop,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { MaritalStatusEnum, UpdateZyqSceneEnum, UpdateZyqSourceEnum } from '@/api/userPersonalInfo/types';
import { SceneTypeEnum } from '@/enums/scene-type';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { CONTACT_SPOUSE_RELATION_CODE, VerifyEntireTypeEnum } from '@/views_v2/verify-credit/types';
import type { VerifyStageContext } from '@/views_v2/verify-credit/types';
import { SupportComponents } from '@/components/new-info-complete/components';
import { InfoComplementField, ProfessionType, specArrCode } from '@/components/new-info-complete/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { VNode } from 'vue';
import { leadTrailTrim, trimAll } from '@/shared/utils/trim';
import { isConfigSupplyPersonalScene } from '@/views_v2/verify-credit/const';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import VerifyBasicPersonal from '../../../mixins/verify-basic-personal';
import BasicPersonalHeader from '../../basic-personal-header';
import {
  ProfileFieldEnum, AdditionalSupplyConfig, ProfileInstance, ContactItemInfo,
  CommonNeedFillStaticFields,
} from './types';
import {
  ExcludeDynamicSupplyField, ContactSpouseFields, SelfCommodityId,
  generateCommonFieldConfig,
  createGroupFieldName,
  makeProfessionBeforeIndustry,
} from './form-fields';
import { submitBtnClickCustomUbt } from './ubt.config';

import style from './index.module.scss';

const PersonalProfileStore = namespace('personalProfile');

@Component({
  name: ' PersonalProfile',
})
export default class PersonalProfile extends Mixins(VerifyBasicPersonal) {
  @Prop(Boolean) readonly processIsLastVerify!: boolean;

  @Prop(String) readonly verifyScene!: VerifySceneEnum;

  @Prop([String]) readonly commodityIds!: string[];

  @Prop(String) readonly verifyEntireType!: VerifyEntireTypeEnum;

  @Prop(Object) readonly verifyStageContext!: VerifyStageContext;

  @Prop(Boolean) readonly isVerifyStageHeaderUINew!: boolean;

  @Prop(Object) readonly queryParams!: Record<string, unknown>;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  @PersonalProfileStore.State formData!: UserVo.PersonalInfo & ContactItemInfo;

  @PersonalProfileStore.State userEmergencyContacts!: UserVo.ContactInfo[];

  @PersonalProfileStore.Action initFormData!: () => Promise<void>;

  @PersonalProfileStore.Action initSelectOptions!: () => Promise<void>;

  @PersonalProfileStore.Action $updateState!: (data: Dictionary) => void;

  @PersonalProfileStore.State userBaseId!: string | null;

  /** 底部按钮文案 */
  private get confirmText() {
    if (this.verifyScene === VerifySceneEnum.MARKET_PRE_SUPPLEMENT) {
      return this.processIsLastVerify ? '保存并下载' : '下一步';
    }

    return this.processIsLastVerify ? '提交' : '下一步';
  }

  /** 是否提现流程 */
  private get isLoanProcess() {
    return [
      VerifyEntireTypeEnum.LOAN,
      VerifyEntireTypeEnum.PRE_CREDIT,
    ].includes(this.verifyEntireType);
  }

  /** 其他资料补充配置(读取服务端接口) */
  private additionalSupplyConfig: AdditionalSupplyConfig = [];

  /** 是否需要更新联系人: 1. 已婚 > 要求有一配偶  2. 未婚 > 要求无已配偶 */
  private shouldUpdateContacts = false;

  /** 联系人中 关系 是配偶 个数 */
  private get spouseContactList() {
    return (this.userEmergencyContacts || []).filter(
      (item) => Number(item.contactRelation) === CONTACT_SPOUSE_RELATION_CODE,
    );
  }

  /** 无需通用的静态字段(学历、月薪、住址等) */
  private get noNeedCommonStaticFields() {
    return isConfigSupplyPersonalScene(this.verifyScene);
  }

  /** 多个联系人更新的字段 */
  private updateContactsFieldsConfigs: ProfileFieldEnum[][] = [];

  /** 补充资料字段-请求服务通用入参 */
  private get supplySceneType(): SceneTypeEnum {
    if ([
      VerifyEntireTypeEnum.PRE_CREDIT,
      VerifyEntireTypeEnum.LOAN,
    ].includes(this.verifyEntireType)) {
      return SceneTypeEnum.LOAN;
    }

    return SceneTypeEnum.PREAPPLY;
  }

  async created(): Promise<void> {
    this.$ubtModuleExpose(
      'finance_editPlatform',
      'platform',
      this.platformValue,
    );

    // 有渠道 id 时，请求接口返回需要补充的资料数据
    const configList = this.commodityIds && this.commodityIds.length
      ? (await UserPersonalInfoApi.supplyNeedConfig(
        this.commodityIds,
        this.supplySceneType,
      )) : [];

    if (configList.length) {
      const config = [] as AdditionalSupplyConfig;
      if (this.noNeedCommonStaticFields) {
        /** 无基本个人信息四个字段场景，过滤id即可 */
        configList
          .filter((name) => name !== 'id')
          .forEach((name) => {
            config.push(name as ProfileFieldEnum);
          });
      } else {
        configList
          .filter((name) => (!ExcludeDynamicSupplyField.includes(name)))
          .forEach((name) => {
            config.push(name as ProfileFieldEnum);
          });
      }

      /** 渠道自定义字段，确保表单项 “职业”在前，“所属行业”在后 */
      makeProfessionBeforeIndustry(config);

      this.additionalSupplyConfig = config;
    }
  }

  protected async setRequireSpouseInfo(
    commodityId: string,
    maritalStatus: MaritalStatusEnum,
  ): Promise<void> {
    try {
      const {
        emergencyCheck,
        unMarriedCheck,
        riskRequireContactsCheck,
        lockEmergency,
        lockUnMarried,
      } = await personalInfoCheck(
        commodityId, maritalStatus,
      );

      this.$emit('updateVerifyStageContext', {
        requireSpouseInfo: !!emergencyCheck,
        requireNoSpouseInfo: !!unMarriedCheck,
        lockSpouseInfo: !!lockEmergency,
        lockNoSpouseInfo: !!lockUnMarried,
        requireContactsInfo: !!riskRequireContactsCheck,
      });
    } catch (err) {
      ubtSendError(err as Error);
    }
  }

  private async initSupplyFormFields() {
    const updateFormFields = {} as Dictionary;

    if (this.formData && this.formData.maritalStatus) {
      await this.specialHandleForMarital(this.formData.maritalStatus, updateFormFields);
    }

    const { profession, industry } = this.formData || {};

    // 针对自营B 有职业 行业, 但是不匹配 表单初始化时，行业 职业表单数据清空
    if (profession && industry
      && this.supplySceneType === SceneTypeEnum.LOAN
      && this.commodityIds.includes(SelfCommodityId)
      && (!(
        (profession === ProfessionType.AGRICULTURE && industry === 101)
        || (profession === ProfessionType.TRANSPORT && specArrCode.indexOf(industry) >= 0)
      ))
    ) {
      this.formData.industry = undefined;
      this.formData.profession = undefined;
    }

    this.$updateState({
      formData: {
        ...this.formData,
        ...updateFormFields,
      },
    });
  }

  async mounted(): Promise<void> {
    if (!IS_PRERENDERING) {
      await this.initFormData();

      this.checkFormReady();
      this.initSupplyFormFields();
      this.$emit('ubtExposeModule');
    }
  }

  /** 单个动态表单组件的生成方法 */
  private createOneDynamicComponent(fieldName: ProfileFieldEnum, listIdx?: number) {
    const propName = fieldName as keyof Partial<UserVo.PersonalInfo>;
    const componentName = (typeof listIdx === 'number'
      ? createGroupFieldName(propName, listIdx)
      : propName) as keyof Partial<UserVo.PersonalInfo>;
    const ComponentElement = SupportComponents.getComponent(propName);

    if (ComponentElement && this.formData) {
      return (
        <ComponentElement
          ref={componentName}
          class="verifyCreditField"
          v-model={this.formData[componentName]}
          onImportPhone={(phone: string, groupIndex?: number) => {
            // 确定要更新的 contactPhone 字段名
            const phoneFieldName = (typeof groupIndex === 'number'
              ? createGroupFieldName('contactPhone', groupIndex - 1)
              : 'contactPhone') as keyof Partial<UserVo.PersonalInfo>;
            // 更新手机号字段
            this.onChangeFormData(phoneFieldName, phone);
          }}
          onChange={(val: string) => this.onChangeFormData(componentName, val)}
          {...generateCommonFieldConfig(this as unknown as ProfileInstance,
            fieldName, componentName, this.commodityIds[0])}
        />);
    }

    return null;
  }

  /** 个人动态配置的信息字段表单渲染 */
  private get personalDynamicConfigFields() {
    const dynamicFields: (VNode | null)[] = [];

    /** 接口返回需要补充的资料字段，授信&提现补充资料场景 */
    if (this.additionalSupplyConfig.length) {
      this.additionalSupplyConfig.forEach(
        (name) => dynamicFields.push(this.createOneDynamicComponent(name)),
      );
    }

    return dynamicFields;
  }

  /** 婚姻状态关联“联系人信息”-动态组件表单渲染 */
  private get maritalRelationDynamicContact() {
    const dynamicFields: (VNode | null)[] = [];
    /** 需要更新多个联系人场景 */
    if (this.updateContactsFieldsConfigs.length) {
      this.updateContactsFieldsConfigs.forEach((list, idx: number) => {
        dynamicFields.push(...list.map(
          (name: ProfileFieldEnum) => this.createOneDynamicComponent(name, idx),
        ));
      });
    }

    return dynamicFields;
  }

  // 判断动态补充资料字段是否检验通过
  private async supplyDynamicValidates(): Promise<boolean> {
    let validateResult = true;
    const fieldsValidate = async (fieldList: string[]) => {
      const len = fieldList.length;

      for (let i = 0; i < len; i++) {
        const name = fieldList[i];
        const $fieldRef = this.$refs[name] as InfoComplementField;

        if ($fieldRef && typeof $fieldRef.onValidator === 'function' && Boolean(await $fieldRef.onValidator()) === false) {
          validateResult = false;
        }
      }
    };

    try {
      await fieldsValidate(CommonNeedFillStaticFields);
      await fieldsValidate(this.additionalSupplyConfig);

      for (let i = 0; i < this.updateContactsFieldsConfigs.length; i++) {
        const fields = this.updateContactsFieldsConfigs[i];
        await fieldsValidate(fields.map((name) => createGroupFieldName(name, i)));
      }
      return validateResult;
    } catch (err) {
      return true;
    }
  }

  private async onChangeFormData(
    propName: keyof Partial<UserVo.PersonalInfo>,
    propValue: string | number,
  ) {
    const updateFormFields = { [propName]: propValue } as Dictionary;
    // 自营 B渠道 根据行业限定职业
    if (propName === ProfileFieldEnum.PROFESSION && this.commodityIds.includes(SelfCommodityId)) {
      const $industryRefElement = this.$refs.industry as InfoComplementField;

      if ($industryRefElement && typeof $industryRefElement.changeOptions === 'function') {
        $industryRefElement.changeOptions(propValue);
      }
    }
    /** 婚姻状态-特殊处理(联系人信息有无配偶的锁定) */
    if (propName === ProfileFieldEnum.MARITAL_STATUS) {
      await this.specialHandleForMarital(propValue, updateFormFields);
    }

    this.$updateState({
      formData: {
        ...this.formData,
        ...updateFormFields,
      },
    });
  }

  /** 个人指定的4条基本信息字段(学历、月薪、居住地、详细地址) */
  private get personalSpecifyBaseFields(): VNode[] {
    /** 普通流程的supply字段场景 */
    if (this.noNeedCommonStaticFields) {
      return [];
    }

    return CommonNeedFillStaticFields.map(
      (name) => this.createOneDynamicComponent(name),
    ).filter((it) => !!it) as VNode[];
  }

  private render() {
    return (
      <div class={[style.container]} ref="profile">
        <BasicPersonalHeader
          isVerifyStageHeaderUINew={this.isVerifyStageHeaderUINew}
          verifyScene={this.verifyScene}
          isLoanProcess={this.verifyEntireType === VerifyEntireTypeEnum.LOAN}
          ocrAfterLoan={this.ocrAfterLoan}
        />
        <Form class={style.formBox} ref="form" onSubmit={this.onSubmit}>
          {
            <div class={style.personalFieldsBox}>
              {...this.personalSpecifyBaseFields}
              {...this.personalDynamicConfigFields}
            </div>
          }
          {
            this.maritalRelationDynamicContact.length ? (
              <div class={style.dynamicContactBox}>
                {...this.maritalRelationDynamicContact}
              </div>
            ) : null
          }
        </Form>
        <div class={style.buttonBox}>
          <Button
            block
            onClick={this.onSubmitButtonClick.bind(this)}
            class={style.submitButton}
          >
            {this.confirmText}
          </Button>
        </div>
      </div>
    );
  }

  /** 用户-婚姻状态特殊处理（自营-关联到紧急联系人） */
  private async specialHandleForMarital(
    fieldValue: string | number,
    updateFormFields: Dictionary = {},
  ) {
    if (this.isLoanProcess) {
      const maritalStatus = Number(fieldValue) as MaritalStatusEnum;
      /** 更新 verifyStageContext */
      await this.setRequireSpouseInfo(this.commodityIds[0], maritalStatus);
      const {
        requireSpouseInfo,
        requireNoSpouseInfo,
        requireContactsInfo,
        lockSpouseInfo,
        lockNoSpouseInfo,
      } = this.verifyStageContext;

      this.shouldUpdateContacts = false;

      /** 选择”已婚“，需要补充配偶联系人信息，（联系人无中配偶）,联系人1需要锁定配偶, 联系人2不能选择配偶 */
      if (maritalStatus === MaritalStatusEnum.MARRIED
        && (requireSpouseInfo || requireContactsInfo)) {
        /** 展示联系人1，2 表单 */
        (!this.updateContactsFieldsConfigs.length)
          && this.userEmergencyContacts.forEach((item, idx) => {
            this.updateContactsFieldsConfigs.push(ContactSpouseFields);
            /** 联系人信息填充 */
            Object.assign(updateFormFields, {
              [createGroupFieldName('contactName', idx)]: item.contactName,
              [createGroupFieldName('contactPhone', idx)]: item.contactPhone,
              [createGroupFieldName('contactRelation', idx)]: item.contactRelation,
            });
          });

        if (lockSpouseInfo) {
          /** 如果联系人关系都不为配偶，则设置联系人1为配偶 */
          if (updateFormFields.contactRelation__0 !== CONTACT_SPOUSE_RELATION_CODE
            && updateFormFields.contactRelation__1 !== CONTACT_SPOUSE_RELATION_CODE) {
            updateFormFields.contactRelation__0 = CONTACT_SPOUSE_RELATION_CODE;
          }
          /** 如果联系人关系都为配偶，则清空联系人2关系 */
          if (updateFormFields.contactRelation__0 === CONTACT_SPOUSE_RELATION_CODE
            && updateFormFields.contactRelation__1 === CONTACT_SPOUSE_RELATION_CODE) {
            updateFormFields.contactRelation__1 = undefined;
          }
        }

        this.shouldUpdateContacts = true;
      } else if (
        maritalStatus !== MaritalStatusEnum.MARRIED
        && ((requireNoSpouseInfo
        && this.spouseContactList.length) || requireContactsInfo)) {
        /** 选择除”已婚“的其他：未婚等，联系人1，2 不能包含配偶，如果原先是配偶，需要清空 */
        (!this.updateContactsFieldsConfigs.length)
          && this.userEmergencyContacts.forEach((item, idx) => {
            this.updateContactsFieldsConfigs.push(ContactSpouseFields);
            Object.assign(updateFormFields, {
              [createGroupFieldName('contactName', idx)]: item.contactName,
              [createGroupFieldName('contactPhone', idx)]: item.contactPhone,
              [createGroupFieldName('contactRelation', idx)]: item.contactRelation,
            });
          });

        /** 在风控都展示联系人信息情况下，如果锁无配偶信息，在切换时如果联系人信息为配偶，清空联系人关系 */
        if (lockNoSpouseInfo) {
          if (updateFormFields.contactRelation__0 === CONTACT_SPOUSE_RELATION_CODE) {
            updateFormFields.contactRelation__0 = undefined;
          }
          if (updateFormFields.contactRelation__1 === CONTACT_SPOUSE_RELATION_CODE) {
            updateFormFields.contactRelation__1 = undefined;
          }
        }

        this.shouldUpdateContacts = true;
      } else {
        /** 联系人表单重置，避免多个联系人表单信息叠加 */
        this.updateContactsFieldsConfigs.splice(0);
        this.additionalSupplyConfig = this.additionalSupplyConfig
          .filter((name) => !ContactSpouseFields.includes(name));
      }
      setTimeout(() => {
        /** 命中风控规则，展示联系人信息，校验联系人手机号是否可用 */
        if (requireContactsInfo) {
          ['contactPhone__0', 'contactPhone__1'].forEach((name) => {
            const $fieldRef = this.$refs[name] as InfoComplementField;
            if ($fieldRef && typeof $fieldRef.onValidator === 'function') {
              $fieldRef.onValidator();
            }
          });
        }
      }, 0);
    }
  }

  public async onFieldChange(
    fieldName: string,
    buttonName: string,
    fieldValue: string,
  ): Promise<void> {
    this.$ubtPageButton(buttonName, 'fieldValue', fieldValue);
    const updateFormFields = { [fieldName]: fieldValue } as Dictionary;

    if (fieldName === ProfileFieldEnum.MARITAL_STATUS) {
      await this.specialHandleForMarital(fieldValue, updateFormFields);
    }

    this.$updateState({
      formData: {
        ...this.formData,
        ...updateFormFields,
      },
    });
  }

  @Debounce(200)
  private onSubmitButtonClick() {
    if (this.$refs.form) {
      (this.$refs.form as Form).submitForm();
    }
  }

  private getGroupFieldValue(name: string, idx: number) {
    if (this.formData) {
      return this.formData[createGroupFieldName(name, idx) as ProfileFieldEnum] as string;
    }

    return '';
  }

  private async onSubmit(errors: ValidateError[]): Promise<void> {
    if (await this.checkPreVerifySubmitState(this.verifyScene)) {
      this.$emit('ubtClickSubmit');
      this.$ubtPageButton(
        'finance_submitPlatform',
        'platform',
        this.platformValue,
      );
      /** 各场景自定义-点击提交按钮的上报埋点 */
      submitBtnClickCustomUbt(this);

      const validateRes = await this.supplyDynamicValidates();

      if (!validateRes || errors.length) {
        // eslint-disable-next-line no-unused-expressions
        errors.length && Toast(errors[0].message);
        return;
      }

      if (this.formData && this.submitBtnInLoading === false) {
        this.submitBtnInLoading = true;

        try {
          const {
            educationDegree, liveAddress, liveAddressDetails, preTaxMonthSalary,
          } = this.formData;
          const baseInfo = {
            educationDegree,
            liveAddress,
            liveAddressDetails: leadTrailTrim(liveAddressDetails),
            preTaxMonthSalary,
          } as UserVo.PersonalInfo;
          let { userBaseId } = this;

          if (!this.noNeedCommonStaticFields) {
            const data = await UserPersonalInfoApi.updateZYQ({
              ...baseInfo,
              updateSource: UpdateZyqSourceEnum.HOME_PAGE,
              updateScene: UpdateZyqSceneEnum.BASE_INFO,
            });

            userBaseId = data.userBaseId;
          }

          if (this.additionalSupplyConfig.length || this.updateContactsFieldsConfigs.length) {
            const updateQuery = { commodityIds: this.commodityIds, id: userBaseId } as Dictionary;

            this.additionalSupplyConfig.forEach((fieldName) => {
              const name = fieldName as unknown as ProfileFieldEnum;

              if (!ContactSpouseFields.includes(name)) {
                updateQuery[name] = this.formData
                  ? ((this.formData as unknown as Dictionary<string>)[name]) : null;
              }
            });

            /** 提现场景：全量传输基本字段到 supplySave 接口（只传有值的字段） */
            if (this.supplySceneType === SceneTypeEnum.LOAN) {
              CommonNeedFillStaticFields.forEach((fieldName) => {
                const value = this.formData?.[fieldName as keyof UserVo.PersonalInfo];
                // 只传有值的字段，字符串类型额外排除空串
                if (value !== undefined && value !== null && value !== '') {
                  updateQuery[fieldName] = value;
                }
              });
            }

            if (this.shouldUpdateContacts && this.updateContactsFieldsConfigs.length) {
              updateQuery.emergencyContactList = [];

              updateQuery.emergencyContactList = this.updateContactsFieldsConfigs.map((_, idx) => ({
                contactName: this.getGroupFieldValue('contactName', idx),
                contactPhone: trimAll(this.getGroupFieldValue('contactPhone', idx)),
                contactRelation: this.getGroupFieldValue('contactRelation', idx),
              }));
            } else if (this.shouldUpdateContacts
                && this.additionalSupplyConfig.includes(ContactSpouseFields[0])) {
              updateQuery.emergencyContacts = {
                contactName: this.formData.contactName,
                contactPhone: trimAll(this.formData.contactPhone),
                contactRelation: this.formData.contactRelation,
              };
            }

            /** 提交“supplyNeedConfig接口”标识 需要额外填写的字段 */
            await UserPersonalInfoApi.supplySave(
              updateQuery,
              this.supplySceneType,
            );
          }

          this.$emit('resolveProcessVerify');
        } catch (error) {
          ubtSendError(error as Error);
        } finally {
          this.submitBtnInLoading = false;
        }
      }
    }
  }
}
